import type { FC, ReactElement } from "react";
import { createContext, useContext } from "react";

import useSchedulePermissions from "@/hooks/useSchedulePermissions";

const SchedulingContext = createContext<
  undefined | UseSchedulePermissionsState
>(undefined);

interface SchedulePermissionsContextProviderProps {
  children: ReactElement | ReactElement[];
}

const SchedulePermissionsContextProvider: FC<
  SchedulePermissionsContextProviderProps
> = ({ children }) => {
  const value = useSchedulePermissions();

  return (
    <SchedulingContext.Provider value={value}>
      {children}
    </SchedulingContext.Provider>
  );
};

const useSchedulePermissionsContext = (): UseSchedulePermissionsState => {
  const context = useContext(SchedulingContext);

  if (context === undefined) {
    throw new Error(
      "useSchedulePermissions must be used within a SchedulePermissionsContextProvider",
    );
  }

  return context;
};

export { SchedulePermissionsContextProvider, useSchedulePermissionsContext };
